export var ResourceType;

(function (ResourceType) {
  ResourceType["Form"] = "1";
  ResourceType["Grading"] = "2";
  ResourceType["Report"] = "3";
})(ResourceType || (ResourceType = {}));